import { Container } from "@mui/material";
import { styled } from "@mui/material/styles";

export const FilterSlotWrapper = styled(Container)(({ theme }) => ({
  marginBottom: "12px",
  [theme.breakpoints.up("mobile")]: {
    marginBottom: "15px",
  },
}));

export const HeaderSlotWrapper = styled(Container)(({ theme }) => ({
  marginBottom: "10px",
  [theme.breakpoints.up("mobile")]: {
    marginBottom: "15px",
  },
}));
